/**
 * MobileCompanyProfile Component for LOOPINO AI Platform
 * Main container for the unified mobile DNA flow
 */

import React from 'react';
import './MobileCompanyProfile.css';

import MobileCompanyProfileFlow from './MobileCompanyProfileFlow';

const MobileCompanyProfile = ({ onBack, companyId = null }) => {
  return <MobileCompanyProfileFlow onBack={onBack} companyId={companyId} />;
};

export default MobileCompanyProfile;
